const newrelic = window.newrelic || null;

export { newrelic };
